import React, { useContext } from 'react'
import Countdown from 'react-countdown'
import PropTypes from 'prop-types'

import { translate } from '../../helpers/stringHelpers'
import { millisToLocaleString } from '../../helpers/dateHelpers'
import ConfigContext from '../../contexts/configContext'
import CountdownAuctionStarts from '../countdownAuctionStarts'
import CountdownAuctionEnds from '../countdownAuctionEnds'

const COUNTDOWN_CLASS_NAME = 'listing-card__countdown'

const ListingCountdown = ({ type, endsAt, auctionStartsAt, hasStarted, isInOvertime }) => {
  const { timeOffset } = useContext(ConfigContext)
  switch (type) {
    case 'webcast':
      return (
        <span className={`${COUNTDOWN_CLASS_NAME} ${COUNTDOWN_CLASS_NAME}--webcast`}>
          {translate('JspPublicCodes_JSP_SALE_STARTS').replace('{0}', millisToLocaleString(auctionStartsAt))}
        </span>
      )
    case 'listing':
      return (
        <span className={`${COUNTDOWN_CLASS_NAME} ${COUNTDOWN_CLASS_NAME}--listing`}>
          {translate('ItemMessageStatus_LISTING_ENDS_MESSAGE').replace('{0}', millisToLocaleString(endsAt))}
        </span>
      )
    case 'lot': {
      return hasStarted
        ? (
          <Countdown
            date={endsAt + timeOffset}
            key={`countdown-${endsAt}`}
            renderer={({ days, hours, minutes, seconds, completed }) => (
              <CountdownAuctionEnds
                completed={completed}
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
                isInOvertime={isInOvertime}
                endsAt={endsAt}
              />)}
          />
          )
        : (
          <Countdown
            date={auctionStartsAt}
            renderer={({ completed }) => (
              <CountdownAuctionStarts
                completed={completed}
                endsAt={endsAt}
                startsAt={auctionStartsAt}
              />
            )}
          />
          )
    }
    default:
      return null
  }
}

ListingCountdown.propTypes = {
  auctionStartsAt: PropTypes.number.isRequired,
  endsAt: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  hasStarted: PropTypes.bool,
  isInOvertime: PropTypes.bool
}

export default React.memo(ListingCountdown)
